{
 "name": "0_bug_lady",
 "bin": "0_bug_lady.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "lady_bug", "parent": 1, "t": [-0.3806809,-1.033464,0.2146149], "q": [0,0.04361936,0,0.9990482], "s": [1,1,1]},
  {"name": "Sphere04", "parent": 10, "t": [-4.768372e-07,-4.872047,5.591335], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [1.05,1.05,1.05]},
  {"name": "Sphere03", "parent": 10, "t": [-0.03035851,-4.883663,-2.352694], "q": [0.002290459,0.7371924,0.6756752,0.002291153], "s": [0.95,0.95,0.95]},
  {"name": "Sphere01", "parent": 10, "t": [3.346457,0.1493979,8.937792], "q": [0.0009659013,-0.5324403,-0.8128319,0.2362428], "s": [1.2,1.2,1.2]},
  {"name": "Sphere05", "parent": 10, "t": [-3.346455,0.1493984,8.937793], "q": [0.2241438,-0.4829629,-0.8365163,0.1294094], "s": [1.2,1.2,1.2]}
 ],
 "parts": [
  {"node": 11, "vertexCount": 144, "posOffset": 0, "nrmOffset": 1728, "uvOffset": 3456, "material": "0_bug_lady_black", "color": [0.1059,0.1059,0.1059,1]},
  {"node": 12, "vertexCount": 162, "posOffset": 4608, "nrmOffset": 6552, "uvOffset": 8496, "material": "09 - Default", "color": [0.588,0.588,0.588,1], "texture": "lady_bug.png"},
  {"node": 13, "vertexCount": 84, "posOffset": 9792, "nrmOffset": 10800, "uvOffset": 11808, "material": "06 - Default", "color": [0.9882,1,0,1], "texture": "eye.png"},
  {"node": 14, "vertexCount": 84, "posOffset": 12480, "nrmOffset": 13488, "uvOffset": 14496, "material": "06 - Default", "color": [0.9882,1,0,1], "texture": "eye.png"}
 ],
 "anims": [
  {"name": "die", "duration": 0.8, "fps": 30, "frames": 25, "offset": 15168},
  {"name": "infect", "duration": 0.8, "fps": 30, "frames": 25, "offset": 30168},
  {"name": "pick", "duration": 0.96667, "fps": 30, "frames": 30, "offset": 45168},
  {"name": "run", "duration": 0.36667, "fps": 30, "frames": 12, "offset": 63168}
 ]
}
